import classNames from "classnames";
import React from "react";
import SVG from "react-inlinesvg";
import Modal from "react-modal";
import { ajax } from "tsi-common-react/src/utils/ajax";
import { t } from "ttag";

import iconXClose from "../../svg/x-close.svg";
import { SurveyModalPostData } from "../models";

const POSSIBLE_RATINGS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

const submitSurvey = async (
    rating: number,
    email: string,
    onClose: () => void,
): Promise<void> => {
    const data: SurveyModalPostData = {
        brand: "TP",
        program: "survey",
        email: email,
        surveyModalResult: `${rating}`,
    };
    await ajax
        .put("https://api.promosis.com/api/v1/tsi-2263-survey/1870")
        .send(data);
    onClose();
};

const buildRatings = (
    rating: number | null,
    setRating: (rating: number) => void,
): React.ReactNode[] => {
    return POSSIBLE_RATINGS.map((ratingValue) => {
        const classes = classNames({
            "br-current": rating === ratingValue,
        });
        return (
            <a
                key={ratingValue}
                data-rating-value={ratingValue}
                data-rating-text={ratingValue}
                className={classes}
                href="#"
                onClick={(e) => {
                    e.preventDefault();
                    setRating(ratingValue);
                }}
            >
                {ratingValue}
            </a>
        );
    });
};

export const LocatorSurveyModal = (props: {
    email: string;
    isOpen: boolean;
    onClose: () => void;
}): React.ReactNode => {
    const [rating, setRating] = React.useState<number | null>(null);

    const handleSubmit = async (
        e: React.FormEvent<HTMLFormElement>,
    ): Promise<void> => {
        e.preventDefault();
        if (!rating) {
            return;
        }
        await submitSurvey(rating, props.email, props.onClose);
    };

    return (
        <Modal
            aria={{
                modal: true,
            }}
            style={{
                content: {
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    maxHeight: "95%",
                    maxWidth: "542px",
                    width: "96%",
                    overflow: "auto",
                    padding: "40px",
                },
            }}
            // TODO(i18n): Use t tagged template: contentLabel={t`Survey`}
            contentLabel="Survey"
            portalClassName="locator"
            className="locations store-locator-survey modal"
            isOpen={props.isOpen}
            onRequestClose={props.onClose}
            role="dialog"
        >
            <button
                aria-label={t`Close`}
                className="modal-close button--ghost"
                onClick={props.onClose}
            >
                <SVG
                    aria-hidden="true"
                    className="modal-close__icon"
                    src={iconXClose}
                    title={t`Close Icon`}
                />
            </button>
            <div className="send__content survey__carousel">
                {/* TODO(i18n): Use t tagged template: <h2>{t`Your results are on the way…`}</h2> */}
                <h2>Your results are on the way&hellip;</h2>
                {/* TODO(i18n): Use t tagged template: <p className="modal-intro">{t`One quick question. How was your online experience today?`}</p> */}
                <p className="modal-intro">
                    One quick question. How was your online experience today?
                </p>
                <form className="cell2-form" onSubmit={handleSubmit}>
                    <fieldset>
                        {/* TODO(i18n): Use t tagged template: <legend className="ada-screenreader-only">{t`Rate your experience`}</legend> */}
                        <legend className="ada-screenreader-only">
                            Rate your experience
                        </legend>
                        <div className="br-wrapper br-theme-bars-square">
                            <div className="br-widget">
                                {buildRatings(rating, setRating)}
                            </div>
                        </div>
                        <div className="form__field form__field--submit">
                            {/* TODO(i18n): Use t tagged template: value={t`Continue`} */}
                            <input
                                id="survey-cell2-submit-email"
                                type="submit"
                                value="Continue"
                                className="button al-store-locator__button--continue"
                                disabled={!rating}
                            />
                        </div>
                    </fieldset>
                </form>
            </div>
        </Modal>
    );
};
